import { render } from "./EditWorkExperience.vue?vue&type=template&id=1d6a34ae"
import script from "./EditWorkExperience.vue?vue&type=script&lang=js"
export * from "./EditWorkExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__